import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private helpDeskModalState = signal(false);

  isHelpDeskModalOpen$ = this.helpDeskModalState.asReadonly();

  openHelpDeskModal() {
    this.helpDeskModalState.set(true);
  }

  closeHelpDeskModal() {
    this.helpDeskModalState.set(false);
  }
}
